<template>
  <v-card>
    <v-progress-circular v-if="loading"
                         indeterminate
                         color="primary">
    </v-progress-circular>

    <v-card-text>
    <service-properties-view v-if="serviceDTO != null"
                                     :service-d-t-o="serviceDTO">
      <template v-slot:append>
        <entity-properties-row>
          <v-btn v-if="$featurePermissions.serviceCRUD"
                 tile
                 color="primary"
                 @click="openEditDialog">
            {{ $t('actions.modify') }}
            <v-icon right dark>
              mdi-border-color
            </v-icon>
          </v-btn>
        </entity-properties-row>
      </template>
    </service-properties-view>
    <service-dialog ref="serviceDialog" @done="reload"/>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import ServicePropertiesView from '@/views/service/ServicePropertiesView';
import ServiceDialog from '@/views/service/ServiceDialog';
import ServiceService from '@/services/ServiceService';

export default Vue.extend({
  name: 'ServiceDetails',
  components: {
    ServiceDialog,
    ServicePropertiesView,
    EntityPropertiesRow,
  },
  data() {
    return {
      serviceDTO: null,
      loading: false,
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      ServiceService.get(this.serviceId).then(result => {
        this.serviceDTO = result.data;
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.loading = false;
      });
    },

    openEditDialog() {
      this.$refs.serviceDialog.openEditService(this.serviceId);
    },
  },

  computed: {
    serviceId() {
      return parseInt(this.$route.params.id, 10);
    },

  },
});
</script>
